// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ConntionInfo } from '../ConnectionInfo';
export class BrandingUtils {
    // #113904: https://docs.google.com/document/d/1EU6Viz-hJM4K2qPjijk9f0EMScjZkwluXHfN6-XNjIQ/edit#heading=h.7hqfzj122bvh
    static GetBrandingWebHeader(theme) {
        var _a;
        return (_a = ConntionInfo.GetActiveConnectionInfo()) === null || _a === void 0 ? void 0 : _a.GetWebHeaderUrl(theme);
    }
    static GetSplashScreen() {
        var _a;
        return (_a = ConntionInfo.GetActiveConnectionInfo()) === null || _a === void 0 ? void 0 : _a.GetSplashScreenUrl();
    }
    static SetWebPageTitle() {
        var _a;
        // web page title (text in tab), if no in branding return from backup if exist #115286
        const title = document.getElementsByTagName('title')[0];
        if (isNullOrUndefined(title))
            return;
        title.innerHTML = (_a = ConntionInfo.GetActiveConnectionInfo()) === null || _a === void 0 ? void 0 : _a.GetTitle();
    }
    static SetWebFavicon() {
        var _a;
        // web page title (text in tab) #115286
        const favicon = document.getElementById('favicon');
        if (isNullOrUndefined(favicon))
            return;
        const faviconUri = (_a = ConntionInfo.GetActiveConnectionInfo()) === null || _a === void 0 ? void 0 : _a.GetFaviconUrl();
        let newHref = '/favicon.ico';
        if (!isNullOrUndefined(faviconUri)) {
            newHref = faviconUri;
        }
        const newLink = document.createElement('link');
        newLink.id = 'favicon';
        newLink.rel = 'icon';
        newLink.href = newHref;
        newLink.type = 'image/x-icon';
        // Remove the existing favicon link and insert the new one
        favicon.parentNode.replaceChild(newLink, favicon);
    }
    static GetWebSplashScreen() {
        // web page image instead of Earth by default on login screen #115286
        const localFileName = BrandingUtils.GetSplashScreen();
        return localFileName;
    }
    static GetWebLoginBanner(theme) {
        var _a;
        return (_a = ConntionInfo.GetActiveConnectionInfo()) === null || _a === void 0 ? void 0 : _a.GetLoginBannerUrl(theme);
    }
    static GetBrandingWebhookURL() {
        var _a;
        const url = (_a = ConntionInfo.GetActiveConnectionInfo()) === null || _a === void 0 ? void 0 : _a.BrandingWebhookURL;
        if (isValidString(url)) {
            return url;
        }
        else {
            return null;
        }
    }
    static GetBrandingWebhookHelpURL() {
        var _a;
        const url = (_a = ConntionInfo.GetActiveConnectionInfo()) === null || _a === void 0 ? void 0 : _a.BrandingWebhookHelpURL;
        if (isValidString(url)) {
            return url;
        }
        else {
            return null;
        }
    }
    static CreateWebhookURL(apiKey, secretKey) {
        const url = this.GetBrandingWebhookURL();
        if (isValidString(url) && isValidString(apiKey) && isValidString(secretKey)) {
            return `${url}/${apiKey}/${secretKey}`;
        }
        else {
            return null;
        }
    }
}
